export function getErrorContent(resp) {
  if (resp.isSuccess()) {
    return null;
  }

  return {
    errorDetail: resp.data.errors,
    message: resp.message,
    errorCode: resp.code || resp.data.code,
  };
}

export function isCookieError(normalizedError) {
  const err = normalizedError.errorDetail;
  return err && err.message === 'You must enable third-party cookies';
}

export function findIndexMatchingCfiFallBackToBefore(
  orderedItems,
  getItemCfi,
  cfi
) {
  if (orderedItems.length === 0 || !cfi) {
    return -1;
  }
  for (let i = 0; i < orderedItems.length - 1; i++) {
    const compare = window.Jigsaw.CFIUtils.compareCFIs;
    const compareThis = compare(cfi, getItemCfi(orderedItems[i]));
    const compareNext = compare(cfi, getItemCfi(orderedItems[i + 1]));
    if (compareThis === 0 || compareNext < 0) {
      return i;
    }
  }
  return orderedItems.length - 1;
}

function stripAssertions(cfi) {
  return cfi.replace(/ *\[[^\]]*\] */g, '');
}

function getContentDocPath(cfi) {
  if (typeof cfi === 'string' && cfi.indexOf('!') > 0) {
    return stripAssertions(cfi).split('!')[0];
  }
  return null;
}

/**
 * Look for a cfi match within the provided cfi's content document,
 * falling backwards to the nearest item for that doc if an exact match
 * is not found. Return the first item on that page if there is no
 * previous match for that CFI. -1 if no content for that page is available
 * or bad data provided.
 *
 * Assumes orderedItems is sorted
 */
export function findIndexMatchingDocAndCfiFallBackToBefore(
  orderedItems,
  getItemCfi,
  cfi
) {
  if (orderedItems.length === 0 || !cfi) {
    return -1;
  }
  const cfiDoc = getContentDocPath(cfi);
  for (let i = 0; i < orderedItems.length - 1; i++) {
    const compare = window.Jigsaw.CFIUtils.compareCFIs;
    const firstItemCfi = getItemCfi(orderedItems[i]);
    if (cfiDoc === getContentDocPath(firstItemCfi)) {
      const compareThis = compare(cfi, firstItemCfi);
      const compareNext = compare(cfi, getItemCfi(orderedItems[i + 1]));
      if (compareThis === 0 || compareNext < 0) {
        return i;
      }
    }
  }
  return -1;
}

export function findIndexMatchingCfiFallBackToAfter(
  orderedItems,
  getItemCfi,
  cfi
) {
  if (orderedItems.length === 0 || !cfi) {
    return -1;
  }
  for (let i = 0; i < orderedItems.length - 1; i++) {
    const compare = window.Jigsaw.CFIUtils.compareCFIs;
    const compareThis = compare(cfi, getItemCfi(orderedItems[i]));
    const compareNext = compare(cfi, getItemCfi(orderedItems[i + 1]));
    if (compareThis === 0) {
      return i;
    } else if (compareNext < 0) {
      return i + 1;
    }
  }
  return orderedItems.length - 1;
}



// WEBPACK FOOTER //
// ./src/app/api/jigsaw-helpers.js